import type { AvatarConfig } from './avatar-catalog'

type Props = Pick<AvatarConfig, 'hair' | 'hairColor'> & { back?: boolean }

export function AvatarHair({ hair, hairColor: color, back = false }: Props) {
  if (hair === 'bald') return null
  if (back) {
    if (hair === 'long' || hair === 'waves' || hair === 'braids') {
      return (
        <g fill={color}>
          <path d="M61 115Q43 54 87 39Q121 20 158 42Q199 55 180 118L193 219Q171 236 150 209L91 209Q65 236 46 214Z" />
          {hair === 'waves' && (
            <path d="M58 107Q30 134 49 155Q25 180 47 202Q26 228 62 239L86 196L159 195Q182 246 200 224Q216 210 194 193Q218 171 192 149Q209 117 177 98Z" />
          )}
          {hair === 'braids' && (
            <g fill="none" stroke="#000" strokeOpacity=".12" strokeWidth="5">
              <path d="M65 145l10 13-10 13 10 13-10 13 10 13" />
              <path d="M176 145l-10 13 10 13-10 13 10 13-10 13" />
            </g>
          )}
        </g>
      )
    }
    if (hair === 'ponytail')
      return (
        <path
          d="M158 78Q210 44 211 108Q207 150 224 180Q186 203 180 157L161 102Z"
          fill={color}
        />
      )
    if (hair === 'bob')
      return (
        <path
          d="M56 100Q48 35 119 32Q189 35 184 105L189 177Q162 201 148 176H89Q68 196 51 175Z"
          fill={color}
        />
      )
    if (hair === 'afro')
      return (
        <g fill={color}>
          <circle cx="119" cy="86" r="72" />
          {[
            [64, 71],
            [72, 39],
            [107, 26],
            [143, 26],
            [170, 42],
            [184, 72],
            [180, 105],
            [58, 108],
          ].map(([x, y]) => (
            <circle key={`${x}-${y}`} cx={x} cy={y} r="25" />
          ))}
        </g>
      )
    if (hair === 'bun')
      return (
        <g fill={color}>
          <circle cx="120" cy="40" r="32" />
          <path d="M68 92Q56 43 118 42Q181 40 174 93Z" />
        </g>
      )
    return null
  }
  return (
    <g fill={color}>
      {hair === 'crop' && (
        <path d="M64 99L63 69Q67 42 100 43L143 43Q176 47 176 78L175 102 163 91 160 71Q120 89 78 73L77 100Z" />
      )}
      {hair === 'quiff' && (
        <path d="M63 111L58 81Q50 55 78 45Q69 28 87 24Q107 42 133 23Q162 4 174 30Q193 56 165 72L175 77 176 107 164 97 157 65Q113 90 78 74L76 112Z" />
      )}
      {hair === 'side' && (
        <path d="M62 110Q48 74 69 51Q101 26 143 39Q184 46 177 108L166 104 159 66Q138 88 79 92L74 112Z" />
      )}
      {hair === 'curly' && (
        <g>
          {[
            [67, 76, 20],
            [79, 52, 23],
            [108, 44, 24],
            [139, 42, 24],
            [161, 60, 24],
            [174, 85, 15],
          ].map(([x, y, r]) => (
            <circle key={x} cx={x} cy={y} r={r} />
          ))}
          <path d="M57 84h20v28l-13-6ZM162 80h20v24l-14 8Z" />
        </g>
      )}
      {hair === 'afro' && (
        <path d="M59 118Q62 91 81 83Q101 92 117 75Q138 94 158 82Q178 91 178 116L187 104 179 54 67 49 53 101Z" />
      )}
      {hair === 'bob' && (
        <path d="M57 110Q49 36 120 35Q185 37 183 105L169 121 159 75Q140 90 80 77L72 121Z" />
      )}
      {(hair === 'long' || hair === 'braids') && (
        <path d="M58 122Q49 35 119 34Q185 35 184 117L170 127 162 84Q136 79 120 58Q105 83 77 88L72 127Z" />
      )}
      {hair === 'waves' && (
        <path d="M53 116Q45 87 59 57Q87 26 117 34Q159 24 180 59Q195 91 177 122L167 113Q163 90 146 82Q119 72 113 57Q113 85 80 94L71 119Z" />
      )}
      {(hair === 'bun' || hair === 'ponytail') && (
        <path d="M62 108Q50 69 74 51Q117 25 158 49Q185 69 177 108L167 108 161 79Q131 80 112 60Q99 84 76 88L74 110Z" />
      )}
    </g>
  )
}
